<template>
    <div>
        <trial-end-clock
            :title="$t.__('common.labels.account_is_now_inactive')"
            :subtitles="[
                $t.__('common.labels.subscription_expired'),
                $t.__('pages.errors.BasicCartAvailable.to_continue_validate_offer'),
            ]"
        >
            <a
                :href="cartLink"
                :target="provider === 'chargebee' ? '_blank' : '_self'"
                class="primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold"
            >
                {{
                    multipleQuotes
                        ? $l10n.__('Consulter mes offres')
                        : $l10n.__('Valider mon offre')
                }}
            </a>
            <p class="typographies-paragraph-medium-semibold help-message__container">
                {{ $l10n.__('Nous vous invitons à prendre contact avec nos conseillers via le') }}
                <CompassLink
                    :label="$t.__('pages.errors.BasicCartAvailable.tchat')"
                    size="large"
                    link="javascript:;"
                    @click="window.MySupport.getForm()"
                />
            </p>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';

export default {
    components: {
        TrialEndClock,
    },
    props: {
         
        cartLink: {
            type: String,
            require: true,
            default: '',
        },
         
        provider: {
            type: String,
            required: false,
            default: 'stripe',
        },
         
        multipleQuotes: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.help-message__container {
    margin: 0;
}
</style>
